module.exports = __webpack_public_path__ + "assets/icon-next-white.64b32c23.svg";